"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";
import {initInScope,onFind} from "@elements/init-modules-in-scope";
import {findIn,removeClass, findAllIn, on, closest, off, getAttribute, addClass, hasClass, setAttribute} from '@elements/dom-utils';
import {renderTemplate} from "../renderTemplate";

const selectors = {
    base: '.js-simple-nav',
    toggle: '.js-simple-nav__toggle',
    collapse: '.js-simple-nav__collapse',
    overlay: '.js-simple-nav__overlay',
    list: '.js-simple-nav__list',
    toggleOverlay: '.js-simple-nav__toggle-overlay',
    listItem: '.js-simple-nav__list-item',
    listToggle: '.js-simple-nav__list-toggle'
};

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    
    onFind(selectors.base, function (baseElement) {
        let toggles = findAllIn(selectors.toggle, baseElement);
        let collapses = findAllIn(selectors.collapse, baseElement);
        let toggleOverlays = findAllIn(selectors.toggleOverlay, baseElement);

        toggleOverlays.forEach(function(toggleOverlay) {
            on('click', function(evt) {
                let targetId = toggleOverlay.getAttribute('data-nav-overlay-target');
                let overlayItem = findIn(targetId, baseElement);
                let renderTemplateItem = findIn('.js-nav__render-templates', overlayItem);

                if(renderTemplateItem) {
                    renderNavTemplate(renderTemplateItem);
                }

                if(hasClass('show-overlay', overlayItem)) {
                    hideItem(toggleOverlay);
                    hideOverlay(overlayItem);
                    removeClass('body--freezed', document.body);
                } else {
                    showItem(toggleOverlay);
                    showOverlay(overlayItem);
                    addClass('body--freezed', document.body);
                }

            }, toggleOverlay);
        });

        toggles.forEach(function(toggle) {
            // todo aria attributes
            on('click', (evt) => {
                if (hasClass('is-open', toggle)) {
                    hideItems(collapses);
                    hideItems(toggles);
                    if (isMobile()) {
                        removeClass('body--freezed', document.body);
                    }
                } else {
                    showItems(collapses);
                    showItems(toggles);
                    if (isMobile()) {
                        addClass('body--freezed', document.body);
                    }
                }
            }, toggle);
        });


        onFind(selectors.list, function (list) {
            let listItems = findAllIn(selectors.listItem, list);
            let listToggle = findAllIn(selectors.listToggle, list);

            listToggle.forEach(function(item) {
                on('click', function (evt) {
                    let element = evt.target;
                    evt.preventDefault();

                    let parentItem = closest(selectors.listItem, element);

                    if (hasClass('is-open', parentItem)) {
                        if (isMobile()) {
                            hideItem(parentItem);
                        } else {
                            hideItem(parentItem);
                            removeBodyClickHandler(bodyClickHandler);
                        }
                    } else {
                        if (isMobile()) {
                            showItem(parentItem);
                        } else {
                            hideItems(listItems);
                            showItem(parentItem);
                            addBodyClickHandler(bodyClickHandler);
                        }

                    }
                }, item);
            });

            function bodyClickHandler(evt) {
                // if (!(evt.target).closest('.js-mega-nav').length) {
                //     evt.preventDefault();
                //     hideItem($listItems);
                //     removeBodyClickHandler(bodyClickHandler);
                // }
            }
        })



    });
}

function addBodyClickHandler(bodyClickHandler) {
    on('click', bodyClickHandler, document.body);
}
function removeBodyClickHandler(bodyClickHandler) {
    off('click', bodyClickHandler, document.body);
}
function hideItem(item) {
    removeClass('is-open', item);
    setAttribute('aria-expanded', false, item);
}
function hideItems(items) {
    items.forEach(function(item) {
        removeClass('is-open', item);
        setAttribute('aria-expanded', false, item);
    });
}
function showItems(items) {
    items.forEach(function(item) {
        addClass('is-open', item);
        setAttribute('aria-expanded', true, item);
    });
}
function showItem(item) {
    addClass('is-open', item);
    setAttribute('aria-expanded', true, item);
}
function showOverlay(overlay) {
    addClass('show-overlay', overlay);
    setAttribute('aria-expanded', true, overlay);
}
function hideOverlay(overlay) {
    removeClass('show-overlay', overlay);
    setAttribute('aria-expanded', false, overlay);
}

export function renderNavTemplate(renderItem) {
    let template = findIn('.js-render-template__template',renderItem);
    let parent = renderItem.parentNode;

    if(template) {
        renderItem.innerHTML = template.innerHTML;
        removeClass('js-nav__render-template',renderItem);
        removeClass('js-render-template',renderItem);

        template.remove();

        initInScope(renderItem);
    }
}
